export const FETCH_RECORD_HISTORY = 'FETCH_RECORD_HISTORY';
export const CLEAR_RECORD_HISTORY = 'CLEAR_RECORD_HISTORY';
export const SET_CALCULATIONS = 'SET_CALCULATIONS';
export const CLEAR_CALCULATIONS = 'CLEAR_CALCULATIONS';
